import type { NormalisedPermissionAssignment } from "@onhandtech/onhand-fe-shared/lib/api/common/permission-assignments/permission-assignments.types";
import { formatEndpoint } from "@onhandtech/onhand-fe-shared/lib/request";
import type { PayloadAction } from "@reduxjs/toolkit";
import { getConfig } from "config/configuration";
import {
	deleteCampaignPermission,
	postCampaignPermission,
} from "redux/redux-modules";
import type { AddPermissionAssignmentPayload } from "redux/sections/actions";
import { delay, putResolve, select } from "redux-saga/effects";
import { isNormalisedVolunteerGroup } from "utils/type.utils";

import type { ModalCampaigns } from "../campaigns.types";
import { campaignModalsSelector } from "../selectors";

export function* addPermissionAssignmentSaga(
	action: PayloadAction<AddPermissionAssignmentPayload>,
) {
	const { target } = action.payload;

	const campaignModals: ModalCampaigns = yield select(campaignModalsSelector);

	if (!campaignModals.permissions) {
		return [];
	}

	if (campaignModals.permissions.isPublic) {
		// Lets find the public permission we need to get rid of
		const publicPermissionAssignment:
			| NormalisedPermissionAssignment
			| undefined = campaignModals.permissions.permissionAssignments.find(
			(permission) => permission.isPublic,
		);

		if (publicPermissionAssignment) {
			// yield put(setAutomaticallyRemovingPublicPermission(true));

			yield putResolve(
				deleteCampaignPermission.actions.makeRequest({
					url: formatEndpoint(
						getConfig().endpoints.api.v5.campaignDeletePermissions,
						{
							id: publicPermissionAssignment.id,
						},
					),
				}),
			);

			// This is ugly, but we've got no way of knowing if the above request has completed.
			yield delay(500);
		}
	}

	const isTargetVolunteerGroup = isNormalisedVolunteerGroup(target);

	yield putResolve(
		postCampaignPermission.actions.makeRequest({
			payload: {
				permission: "VIEW",
				campaign_id: campaignModals.permissions.id,
				assignee_user_group_id: isTargetVolunteerGroup ? target.id : null,
				assignee_user_id: isTargetVolunteerGroup ? null : (target.id ?? null),
			},
		}),
	);

	return [];
}
